'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _applyConfigs = require('../utils/apply-configs');

var _applyConfigs2 = _interopRequireDefault(_applyConfigs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (node) {
	return {
		type: 'CONTAINER_01',
		name: 'Container',
		allowedSections: ['footer', 'header', 'main'],
		disallowedChildren: ['CELL_01'],
		category: 'Layout',
		props: [],
		hiddenProps: (0, _applyConfigs2.default)(['animations', 'htmlclass']).concat({
			label: 'Device visibility',
			props: [{
				name: 'hideOnMobile',
				inputType: 'checkbox',
				label: 'Show on mobile',
				default: true
			}, {
				name: 'hideOnTablet',
				inputType: 'checkbox',
				label: 'Show on tablet',
				default: true
			}, {
				name: 'hideOnDesktop',
				inputType: 'checkbox',
				label: 'Show on desktop',
				default: true
			}]
		}, {
			label: 'Visibility conditions',
			props: [{
				name: 'conditionTrigger',
				inputType: 'select',
				label: 'Trigger on',
				default: 'NONE',
				values: [{
					label: 'No trigger',
					value: 'NONE'
				}, {
					label: 'Variable value',
					value: 'VARIABLE'
				}]
			}, node && node.props.conditionTrigger === 'VARIABLE' && {
				name: 'conditionVariable',
				inputType: 'select',
				label: 'Variable',
				default: 'NONE',
				values: [{
					label: 'None',
					value: 'NONE'
				}, {
					label: 'Shopcart quantity',
					value: 'shopcart.head.tot_qty_wo_addons'
				}, {
					label: 'Article type',
					value: 'article.article.articleType'
				}, {
					label: 'Url contains',
					value: 'router.canonicalPath'
				}, {
					label: 'Is logged in',
					value: 'customer.logged_in'
				}]
			}, node && node.props.conditionTrigger === 'VARIABLE' && {
				name: 'conditionOperator',
				inputType: 'select',
				label: 'Operator',
				default: 'TRUE',
				values: [{
					label: 'true',
					value: 'TRUE'
				}, {
					label: 'false',
					value: 'FALSE'
				}, {
					label: 'Equal to',
					value: 'EQUAL'
				}, {
					label: 'Not Equal to',
					value: 'NOT_EQUAL'
				}, {
					label: 'Greater than',
					value: 'GREATER_THAN'
				}, {
					label: 'Less than',
					value: 'LESS_THAN'
				}, {
					label: 'Greater than or equal to',
					value: 'GREATER_THAN_OR_EQUAL_TO'
				}, {
					label: 'Less than or equal to',
					value: 'LESS_THAN_OR_EQUAL_TO'
				}, {
					label: 'Contains',
					value: 'CONTAINS'
				}]
			}, node && node.props.conditionTrigger === 'VARIABLE' && node.props.conditionOperator !== 'TRUE' && node.props.conditionOperator !== 'FALSE' && {
				name: 'conditionValue',
				inputType: 'text',
				label: 'Value',
				default: ''
			}, node && node.props.conditionTrigger === 'VARIABLE' && node.props.conditionOperator === 'CONTAINS' && {
				name: 'conditionAction',
				inputType: 'select',
				label: 'Action',
				default: 'SHOW',
				values: ['SHOW', 'HIDE']
			}].filter(Boolean)
		})
	};
};